import Shepherd from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";
import { IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

export function startDashboardTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });

  // Aggiungi i passi del tour qui
  tour.addStep({
    title: "Welcome to the dashboard",
    text: `This tour will guide you through the main features of the dashboard.`,
    attachTo: {
      element: "body",
      on: "auto",
    },
    buttons: [
      {
        action: tour.next,
        text: "Start",
      },
    ],
  });
  tour.addStep({
    title: "Card Online",
    text: "This card shows the online status of LECS and perfect synchronization.",
    attachTo: {
      element: ".onlineCard",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Days Remaining",
    text: "This card shows the days remaining for the end of the license",
    attachTo: {
      element: ".daysRemaining",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Tiresia Load",
    text: "This card shows the learning status of the Tiresia algorithm. When the bar is complete, the AI is at capacity.",
    attachTo: {
      element: ".tiresiaLoad",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Average Bandwidth",
    text: "This card shows the average bandwidth of the last 5 minutes",
    attachTo: {
      element: ".averageBandwidth",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Global Attacks",
    text: "This graph shows the trend in the number of anomalies detected by LECS divided by severity categories. The intelligence shows the number of IOCs related to malicious IP and DNS",
    attachTo: {
      element: ".globalAttack",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Map",
    text: "Map shows real-time geolocation of malicious IP and DNS IOCs detected by LECS",
    attachTo: {
      element: ".miniMap",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Passive Vulnerabilities Score",
    text: "Here you will be able to find a value between 1 and 100 that represents an evaluation based on the analysis of passively observed vulnerabilities from the network analyzed by LECS.",
    attachTo: {
      element: ".ratingGraph",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Highlights",
    text: "This table shows the major anomalies detected by LECS in the last week; color indicates severity ",
    attachTo: {
      element: ".highlights",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });

  // Continua ad aggiungere altri passi secondo necessità

  return tour;
}

function startCriticalTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Critical Table",
    text: "This tab contains the most anomalous LOGs, often related to malware behavior and lateral movements.In these cases, LECS intervenes with both procedural and physical countermeasure.",
    attachTo: {
      element: ".criticalTable",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });

  // Continua ad aggiungere altri passi secondo necessità

  return tour;
}
function startUserOptionTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Accounts Setting",
    text: "Here you have the settings to manage your accounts, secondary and admin",
    attachTo: {
      element: ".accountsSetting",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  })
  tour.addStep({
    title: "Telegram ID",
    text: "Here you can enter your Telegram ID to synchronize our Telegram bot with your LECS, to do this you will first need to go to the telegram bot and request Telegram code generation, then enter it here.",
    attachTo: {
      element: ".telegramIdSetting",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  })

  // Continua ad aggiungere altri passi secondo necessità

  return tour;
}

function startAlertTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Alert Table",
    text: "The LOGs in the alerts show all that telemetry related to abnormal behavior, not overly dangerous but requiring IT attention.",
    attachTo: {
      element: ".alertTable",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });

  return tour;
}


function startTires_IAAnalysis() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Tires-IA ANALYSIS",
    text: "Tires-IA highlights the most anomalous movements recorded by LECS.",
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Tires-IA ANALYSIS TABLE",
    text: "Here you have a table that groups the 10 strangest logs intercepted by AI",
    attachTo: {
      element: ".tires-iaAnalysisTable",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Tires-IA ANALYSIS SCATTER PLOT",
    text: "This is a graph summarizing the data in the table by arranging the various logs as points",
    attachTo: {
      element: ".tires-iaScatterPlot",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });

  return tour;
}


function startHighTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "High table",
    text: "This is where LOGs are found that are not necessarily high-impact, but can be traced within an attack chain. In these LECS intervenes with procedural countermeasure.",
    attachTo: {
      element: ".highTable",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}
function noTutorial() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "No Tutorial is available for this page",
    text: " ",
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}
function startMovementsTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Movements Table",
    text: "In the latter tab, LOGs related to POLICY or behaviors in the internal network that are unusual but generally do not carry real threats are found instead.",
    attachTo: {
      element: ".anomaliesTable",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startInternalDetTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Internal Detection",
    text: "The ranking of IPs that generated the most security LOGs.",
    attachTo: {
      element: ".internalDet",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startThreatIntTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Intelligence Analysis",
    text: "In the Analyses tab is the list of internal IPs that have contacted low reputation external IPs or DNSs.",
    attachTo: {
      element: ".intAnalysis",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Threat Analysis",
    text: "In the Threats Analyses tab is a detail of the timestamps in the table above.",
    attachTo: {
      element: ".threatAnalysis",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startTiresiaHLTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "sheperd-theme",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Tiresia Highlights",
    text: "On the Highlights page we find unique events divided by category that have been detected in recent months.",
    attachTo: {
      element: ".tiresiaHL",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Tiresia Training",
    text: "This is where LOGs are found that are not necessarily high-impact, but can be traced within an attack chain.",
    attachTo: {
      element: ".tiresiatraining",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startAdVisualizerTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Advanced Visualizer",
    text: "Here you can analyze all your logs by managing them through the various filters available.",
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Fast Filter",
    text: "Quick filters grouped by time and type.",
    attachTo: {
      element: ".fastFilters",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Type Filters",
    text: "Filter to set the types of logs to be displayed.",
    attachTo: {
      element: ".typeFilter",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Date Filter",
    text: "Filter to set the range of log days to display.",
    attachTo: {
      element: ".dateFilter",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Detail Filter",
    text: "Enter the detail or a keyword to view only the logs that contain that word.",
    attachTo: {
      element: ".detailFilter",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "IP Filter",
    text: "Enter the Ip pair from which to derive the logs.",
    attachTo: {
      element: ".ipFilter",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Types Graph",
    text: "Here you can see a comparison on the totals of the types you filtered.",
    attachTo: {
      element: ".typesGraph",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Logs Table",
    text: "here you have a table with all the logs resulting from the applied filters.",
    attachTo: {
      element: ".logsTable",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: '3-Day Graph',
    text: 'Here you have a graph comparing the three most recent days of your filter, showing you for each log , the change in quantity for each day.',
    attachTo: {
      element: '.ThreeDaysGraph',
      on: 'top'
    },
    buttons: [
      {
        action: tour.back,
        text: 'Back'
      },
      {
        action: tour.next,
        text: 'Next'
      }
    ]
  });
  tour.addStep({
    title: "Detail Graph",
    text: "Here you have a collection of the logs resulting from the applied filters, and you can select one and see its trend over the past 60 days.",
    attachTo: {
      element: ".detailGraph",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startNetwEntropyTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Tiresia Entropy",
    text: "Entering the world of information theory, the entropy of traffic divided by protocol used is shown.",
    buttons: [
      {
        action: tour.next,
        text: "next",
      },
    ],
  });
  tour.addStep({
    title: "Entropy Graph",
    text: "Visualization of entropy for each protocol type, updated every 10 minutes of the day.",
    attachTo: {
      element: ".graphEntropy",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Entropy Table",
    text: "Summary table of the day's entropy.",
    attachTo: {
      element: ".tableEntropy",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startStatusTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Status",
    text: "In the status we find the iventory at level 2 of the network where LECS is present, as well as RTT and Jitter",
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Device Online",
    text: "Here you have you can view the online devices connected with respect to the threshold entered.",
    attachTo: {
      element: ".onlineDev",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Average Rtt",
    text: "Average of the time between sending a signal and receiving confirmation of its arrival (Round Trip Time).",
    attachTo: {
      element: ".avgrtt",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Average Jitter",
    text: "Average receiving delay of transmitted packets caused by internal queues at congested routers (Jitter).",
    attachTo: {
      element: ".avgjitter",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Insert Threshold",
    text: "Here you can set the threshold represented by the known hosts number.",
    attachTo: {
      element: ".inshost",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Host Online Table",
    text: "Table of all online hosts at this time and related information.",
    attachTo: {
      element: ".onlineDevHost",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Most Delayed Host Table",
    text: "The most delayed online hosts are represented here.",
    attachTo: {
      element: ".delayedHost",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Host Offline Table",
    text: "Here are the known hosts but for some reason they are offline.",
    attachTo: {
      element: ".offlineHost",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

// eslint-disable-next-line no-unused-vars -- defined for the real-time page tour but not yet wired into the Tour path switch below; kept for that future wiring
function startRealTimeTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Real Time Transmission",
    text: "Here we find a summary of network statistics",
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "KB/s 48hrs",
    text: "KBps managed in 48 hours.",
    attachTo: {
      element: ".bps48",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Number of packets",
    text: "Traffic morphology by protocol type.",
    attachTo: {
      element: ".numpackets",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "PPS",
    text: "This number indicates the Packet Per Second from all your host monitored by LECS and the graphics shows you the last 10 values.",
    attachTo: {
      element: ".pps",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "BPS",
    text: "This number indicates the KiloBytes Per Second from all your host monitored by LECS and the graphics shows you the last 10 values.",
    attachTo: {
      element: ".bps",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Network Errors",
    text: "Network background errors percentage.",
    attachTo: {
      element: ".nerror",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Network background noise",
    text: 'The percentage of network "NOISE" is presented here. That is, the difference between Broadcast and Unicast traffic. The lower the value the better. Optimal only 10%.',
    attachTo: {
      element: ".nNoise",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startInfrastructureLogTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Infrastructure Log",
    text: "We find a low-level analysis of network flows and its errors. (TCP)",
    attachTo: {
      element: ".infraLog",
      on: "right",
    },
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startGlobeTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Main Globe",
    text: "Full-screen, real-time map of major external IOCs with IP and DNS. The globe rotates faster if the data is being loaded and slower if the data is already loaded or not found.",
    attachTo: {
      element: ".mainGlobe",
      on: "right",
    },
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Globe Table",
    text: "At the click of an enlightened nation on the globe, you will be able to see here the detected low reputation ip's with whom there has been contact.",
    attachTo: {
      element: ".globeTable",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}
function startTicketTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Ticket",
    text: "Contact support at your distributor or dealer",
    attachTo: {
      on: "right",
    },
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Ticket History",
    text: "Details of submitted tickets can be checked here",
    attachTo: {
      element: ".ticketHistory",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

// eslint-disable-next-line no-unused-vars -- defined for the network-analysis page tour but not yet wired into the Tour path switch below; kept for that future wiring
function startNetwAnalysisTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Network Analyses",
    text: "Here we find the analysis of your network.",
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Analyses Ip",
    text: "Useful tool to analyze the number of network errors detected by LECS divided by IP.",
    attachTo: {
      element: ".analysisIp",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Broadcast Analysis",
    text: "Broadcast indicates the number of broadcasts for each IP detected.",
    attachTo: {
      element: ".broadcastAnalysis",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startAllLecsTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Multi Lecs View",
    text: "Here we find the weekly highlights of all your LECS.",
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Count of Critical and High Logs for LECS",
    text: "Useful tool to see if there have been problems in the network.",
    attachTo: {
      element: ".highGraph",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Count of Alerts Logs for LECS",
    text: "This pie chart shows the number of alerts logs for Lecs",
    attachTo: {
      element: ".lowGraph",
      on: "left",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Critical and High Logs",
    text: "Here are all the Critical and High logs.",
    attachTo: {
      element: ".highDataGrid",
      on: "right",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  tour.addStep({
    title: "Network List",
    text: "This is an ordered list of the LECS with the highest network load.",
    attachTo: {
      element: ".networkList",
      on: "left",
    },
    buttons: [
      {
        action: tour.back,
        text: "Back",
      },
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}

function startLecsManagement() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: "shadow-md bg-purple-dark",
      scrollTo: { behavior: "smooth", block: "center" },
    },
  });
  tour.addStep({
    title: "Lecs Managemet",
    text: "In this page, you can modify log and offline device notifications, adjust log suppression settings, and change device settings.",
    buttons: [
      {
        action: tour.next,
        text: "Next",
      },
    ],
  });
  return tour;
}


const Tour = () => {
  const currentPath = window.location.pathname;

  const startTutorial = () => {
    const tour = currentPath.includes("/user/home")
      ? startDashboardTour()
      : currentPath.includes("/user/security/critical")
        ? startCriticalTour()
        : currentPath.includes("/user/security/high")
          ? startHighTour()
          : currentPath.includes("/user/security/alert")
            ? startAlertTour()
            : currentPath.includes("/user/security/movements")
              ? startMovementsTour()
              : currentPath.includes("/user/security/internal-detection")
                ? startInternalDetTour()
                : currentPath.includes("/user/security/threat-intelligence")
                  ? startThreatIntTour()
                  : currentPath.includes("/user/tiresia-engine/highlights")
                      ? startTiresiaHLTour()
                      : currentPath.includes("/user/tiresia-engine/network-entropy")
                        ? startNetwEntropyTour()
                        : currentPath.includes("/user/tiresia-engine/advanced-visualizer")
                          ? startAdVisualizerTour()
                          : currentPath.includes("/user/network-status/status")
                            ? startStatusTour()
                            : currentPath.includes("/user/network-status/infrastructure-log")
                              ? startInfrastructureLogTour()
                              : currentPath.includes("/user/extra/map")
                                    ? startGlobeTour()
                                    : currentPath.includes("/user/support/ticket")
                                      ? startTicketTour()
                                      : currentPath.includes("/user/tiresia-engine/tiresia-analysis")
                                        ? startTires_IAAnalysis() 
                                        :currentPath.includes("/user/profile")
                                          ? startUserOptionTour()
                                          : currentPath.includes("user/all-lecs-view")
                                            ? startAllLecsTour() 
                                            : currentPath.includes("user/lecs-management")
                                              ? startLecsManagement()
                                              : noTutorial();

    tour && tour.start();
  };

  return (
    <IconButton onClick={startTutorial} title="Start Tutorial of this Page">
      <HelpIcon />

    </IconButton>
  );
};

export default Tour;
